import { useTypedDispatch, useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import { IUserModel } from 'models/User.Model';
import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardFooter, Col, Container, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
// import { HelperConstant } from "../../helpers/HelperConstant";
import PersonalDetailsServices from 'services/PersonalDetails.Services';
import { aes_encryption, countrycodenumber, findedLocation, getCountryCodeStorage, getLocalStorage, isMobile, isValidUser } from 'helpers/Helper';
import { getDecodedAccessToken } from 'helpers/TokenHelper';
import { FilterDataId } from 'features/reducers/filterdata/FilterData.Reducers';
import INDCreateEdit from '../INDCreateEdit';
import UAECreateEdit from '../UAECreateEdit';
import CustomLoader from 'components/Common/CustomLoader';
import { CustomButton } from 'components/shared/CustomButton';
import Paginate from 'components/Common/Paginate';
import UseDebounce from 'components/shared/UseDebounce';
import { HelperConstant } from '../../../helpers/HelperConstant';


function UserDashboard() {

    const dispatch = useTypedDispatch();

    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const [dashbord, setDashbord] = useState<Array<IUserModel>>([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [recordsCount, setRecordsCount] = useState<number>(0);
    const [selectedVal, setSelectedVal] = useState<IUserModel>();
    const [IsPublic, setIsPublic] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [editModal, setEditModal] = useState(0);
    const [createModal, setCreate] = useState(0);
    const [activeUsers, setActiveUsers] = useState<boolean>(true);
    const [profileImage, setProfileImage] = useState<any>();
    const [userId, setuserId] = useState<number>(0);
    const debouncedSearch = UseDebounce(searchText, 1000);
    const [active, setActive] = useState<boolean>(false);
    const [infoOpen, setInfoOpen] = useState<boolean>(false);

    const segmentHandler = (val) => {
        setIsPublic(val);
    }

    const getDashbord = (IsPublic, activeStatus: boolean) => {
        setLoading(true);
        PersonalDetailsServices.GetPersonList({
            OffsetStart: offsetStart,
            RowsPerPage: rowsPerPage,
            SortOrder: '',
            SortOrderColumn: '',
            SearchText: debouncedSearch,
            IsPublic: IsPublic,
            IsActive: activeStatus
        }).then(res => {
            if (res.status === 200) {
                let data: Array<IUserModel> = res.data.Items;
                setDashbord(data);
                setRecordsCount(res.data.RecordsCount);
                setLoading(false);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    function deleteUser(Id: any) {
        PersonalDetailsServices.remove(Id).then((res) => {
            if (res.status === 200) {
                setDashbord(dashbord.filter((item) => item.Id !== Id))
                window.location.href = "/user-dashboard";
            }
        });
    }


    function activateUser(mobile: any, Id: any) {
        PersonalDetailsServices.activate(mobile, Id).then((res) => {
            if (res.status === 200) {
                if (res.data == false) {
                    setIsAlertOpen(false);
                    setInfoOpen(true);
                } else {
                    setDashbord(dashbord.filter((item) => item.Id !== Id))
                    window.location.href = "/user-dashboard";
                }
            }
        });
    }

    const editHandler = (Id) => {
        setuserId(Id)
        setEditModal(Id);
    }

    useEffect(() => {
        isValidUser(getDecodedAccessToken(getLocalStorage().Token));
        getDashbord(IsPublic, activeUsers);
    }, [IsPublic, offsetStart, rowsPerPage, debouncedSearch, activeUsers]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        dispatch(FilterDataId({ payload: 0, type: "OffsetStart" }));
    };

    const reportSegment = [{
        segmentTile: "Public",
        segmentValue: true
    },
    {
        segmentTile: "Management",
        segmentValue: false
    }];

    const reportActiveSegment = [{
        segmentTile: "Active",
        segmentValue: true
    },
    {
        segmentTile: "In-Active",
        segmentValue: false
    }];

    const encryptedUserId = aes_encryption(userId);

    const handleOpenActiveModel = (user: IUserModel) => {
        setSelectedVal(user);
        setActive(user.Active)
        setIsAlertOpen(true);
    }

    return (
        <div className="page-content">
            <Container fluid className="p-0">
                <div>
                    <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>USER LISTS</h5>
                </div>
                <Card>
                    <CardBody className='p-0'>
                        <Row>
                            <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                                <div className="search-box mb-2 me-2">
                                    <div className="position-relative">
                                        <input
                                            type="search"
                                            name='search'
                                            className="form-control bg-light border-light rounded"
                                            placeholder="Search User..."
                                            value={searchText}
                                            onChange={handleSearchChange}
                                        />
                                        <i className="bx bx-search-alt search-icon"></i>
                                    </div>
                                </div>
                            </Col>
                            {!isMobile() &&
                                <>
                                    <Col xl={3} className="text-center">
                                        <div style={{ background: "#FFFFFF", borderRadius: '10px', width: '100%' }} className="d-flex justify-content-around p-2">
                                            {(reportSegment || []).map((sVal: any, idx: number) => {
                                                return (
                                                    <div className={`cursor-pointer px-4 text-center segment ${(IsPublic == sVal.segmentValue) ? 'segment-active' : ""}`} key={idx} onClick={() => segmentHandler(sVal.segmentValue)} >
                                                        <p className={`mb-0 py-2 text-nowrap segment-text dofy-admin-font-sm`} >{sVal.segmentTile}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Col>
                                    <Col xl={3} className="text-center">
                                        <div style={{ background: "#FFFFFF", borderRadius: '0px', width: '100%', borderLeft: '1px solid #000000' }} className="d-flex justify-content-around p-2">
                                            {(reportActiveSegment || []).map((sVal: any, idx: number) => {
                                                return (
                                                    <div className={`cursor-pointer px-4 text-center segment ${(activeUsers == sVal.segmentValue) ? 'segment-active-new' : ""}`} key={idx} onClick={() => setActiveUsers(sVal.segmentValue)} >
                                                        <p className={`mb-0 py-2 text-nowrap segment-text dofy-admin-font-sm`} >{sVal.segmentTile}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Col>
                                    <Col xl={3} className='text-end'>
                                        <CustomButton className='mx-3' onClick={() => setCreate(1)} type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Create'} />
                                    </Col>
                                </>
                            }
                        </Row>
                        {isMobile() &&
                            <Row>
                                <Col>
                                    <div className="form-check form-switch mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="toggle"
                                            checked={IsPublic}
                                            onChange={() => {
                                                setIsPublic(!IsPublic);
                                            }}
                                        />
                                        <label className="form-check-label">{IsPublic ? "Public" : "Management"}</label>
                                    </div>
                                </Col>
                                <Col className="text-center">
                                    <div className="form-check form-switch mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="toggle"
                                            checked={activeUsers}
                                            onChange={() => {
                                                setActiveUsers(!activeUsers);
                                            }}
                                        />
                                        <label className="form-check-label">{activeUsers ? "Active" : "In-Active"}</label>
                                    </div>
                                </Col>
                                <Col className='text-end'>
                                    <CustomButton className='mx-3' onClick={() => setCreate(1)} type={'button'} btnClassName={'btn-success'} iconClasssName={''} name={'Create'} />
                                </Col>
                            </Row>
                        }

                        <CustomLoader isOpen={loading} />

                    </CardBody>
                </Card>

                <Row >
                    {/* <Col xl={12}>
                                <CustomDataTable columns={columns}
                                    data={dashbord}
                                    customPageSize={10}
                                    pageSize={150}
                                    isActionEdit={true}
                                    isActionDelete={true}
                                    selectedPage={pagination}
                                    editHandler={editHandler}
                                    canShowButton1={false}
                                    canShowButton2={false}
                                    deleteHandler={deleteHandler}
                                    routeHandler={CreateHandler}
                                    isPagination={true}
                                    path={'/#'}
                                    firstBtnName={'create'} createHandler={undefined}
                                    recordsCount={recordsCount}
                                    rowName={'Users'} /> 
                    </Col> */}

                    {dashbord.sort((a, b) => b.Modified - a.Modified).map((user, idx) => {
                        return <Col xxl={2} xl={3} lg={3} md={4} sm={6} key={idx}>
                            <Card className="text-center pb-0" style={{ borderTop: '3px outset #1E4496' }}>
                                <CardBody className='p-0'>
                                    <div className="avatar-sm mx-auto mb-3">
                                        <span className={"avatar-title rounded-circle bg-soft bg-info text-dofy font-size-16 fw-bold"} >
                                            {(user.FirstName.charAt(0).toUpperCase())}
                                        </span>
                                    </div>
                                    <h5 className="font-size-15 m-1">
                                        <span className="text-dofy fw-bold mb-1">{user.FirstName}</span>&nbsp;{user.AliasName != "null" && user.AliasName && user.AliasName != null && <><span className='font-size-12'>-</span>&nbsp;<span>{user.AliasName}</span> </>}
                                    </h5>
                                    <p className="text-muted m-1 fw-semibold">{user.UserRoleName}</p>
                                    <p className="m-1" >{countrycodenumber(getCountryCodeStorage()) + user.Mobile}</p>
                                    <p className="font-size-12 m-0 mb-2" >{user.Email}</p>
                                </CardBody>
                                <CardFooter className="bg-transparent border-top pb-0">
                                    <div className={`d-flex ${user.RoleId === HelperConstant.Roles.Public ? "justify-content-center" : "justify-content-between"}`}>
                                        <div className="">
                                            <Label id={"edit" + user.Id}>
                                                <i className="bx bx-edit text-muted cursor-pointer user-icons font-size-18" onClick={() => editHandler(user.Id)} />
                                            </Label>
                                        </div>
                                        {/* <div className="flex-fill">
                                            <Label id={"delete" + user.Id}>
                                                <i className="bx bx-trash-alt text-muted cursor-pointer" onClick={() => deleteHandler(user.Id)} />
                                            </Label>
                                        </div> */}
                                        {user.RoleId !== HelperConstant.Roles.Public &&
                                            <div className="form-check form-switch font-size-14">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizesm"
                                                    // defaultChecked={}
                                                    checked={user.Active}
                                                    onClick={e => {
                                                        handleOpenActiveModel(user)

                                                    }}
                                                />
                                            </div>}
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>

                    })}
                </Row>
                <Modal isOpen={isAlertOpen} centered={true} backdrop size={"sm"}>
                    <div className="modal-content p-0">
                        <ModalBody className="px-2 py-5 text-center">
                            <div className="avatar-sm mb-4 mx-auto">
                                <div className={`${active ? " bg-danger" : " bg-primary"} avatar-title text-primary bg-opacity-10 fs-1 rounded-3`}>
                                    <i className={`bx bx-error ${active ? " text-danger" : " text-primary"}`}></i>
                                </div>
                            </div>
                            <p className="text-muted font-size-14 mb-4">{active ? "Are you sure you want to In-Active this user?" : "Are you sure you want to Active this user?"}</p>

                            <div className="hstack gap-2 justify-content-center mb-0">
                                <button type="button" className="btn btn-soft-secondary" onClick={() => { setIsAlertOpen(false); }}>Close</button>
                                {active ?
                                    <button type="button" className={`btn btn-danger`} onClick={() => deleteUser(selectedVal?.Id)}>In-Active</button> :
                                    <button type="button" className="btn btn-primary" onClick={() => activateUser(selectedVal?.Mobile, selectedVal?.Id)}>Active</button>
                                }
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
                <Modal size='lg' isOpen={editModal > 0} toggle={() => setEditModal(0)} centered>
                    <ModalHeader toggle={() => setEditModal(0)}>
                        <div className=''>
                            <i className='fas fa-user-edit text-dofy me-2 font-size-15 '></i>
                            <span className='font-size-16 fw-semibold text-dofy'>User Edit</span>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {findedLocation().CountryCode == "in" ?
                            <INDCreateEdit id={editModal} setEditModal={setEditModal} userId={encryptedUserId} />
                            :
                            <UAECreateEdit id={editModal} setEditModal={setEditModal} userId={encryptedUserId} />
                        }
                    </ModalBody>
                </Modal>

                <Modal size='lg' isOpen={createModal > 0} toggle={() => setCreate(0)} centered>
                    <ModalHeader toggle={() => setCreate(0)}>
                        <div className=''>
                            <i className='fas fa-user-plus text-dofy me-2 font-size-15 '></i>
                            <span className='font-size-16 fw-semibold text-dofy'>User Create</span>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {findedLocation().CountryCode == "in" ?
                            <INDCreateEdit id={0} setEditModal={setCreate} />
                            :
                            <UAECreateEdit id={0} setEditModal={setCreate} />
                        }
                    </ModalBody>
                </Modal>

                <Modal size='md' isOpen={infoOpen} toggle={() => setInfoOpen(false)} centered>
                    <ModalBody>
                        <div className="avatar-sm mb-4 mx-auto">
                            <div className="avatar-title text-primary bg-opacity-10 fs-1 rounded-3">
                                <i className="bx bx-error text-white"></i>
                            </div>
                        </div>
                        <p className="text-muted font-size-14 mb-4 text-center">User is already registered with same mobile number is Active.</p>
                        <div className="hstack gap-2 justify-content-center mb-0">
                            <button type="button" className="btn btn-soft-secondary" onClick={() => { setInfoOpen(false) }}>Close</button>
                        </div>
                    </ModalBody>
                </Modal>
                {recordsCount > rowsPerPage && <Paginate recordsCount={recordsCount} rowName={'Users'} rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart} />}
            </Container>
        </div>
    )
}

export default UserDashboard
